import styled from 'styled-components';
import { StockModelCardCaptionStyled } from '../StockModelCardCaptionStyled';
import { rem } from 'polished';

export const StockModelCardCaptionStyledAC = styled(StockModelCardCaptionStyled)`
    .stockModelCard-imageContainer--info__list {
        dd {
            font-size: ${rem('14px')};
            color: ${({ theme }) => theme.colors.grey5};
        }
    }

    .highlighted-text {
        color: ${({ theme }) => theme.colors.grey5};
        font-size: ${rem('14px')};
    }
`;
